// 角色-菜单的api
import request from '@/utils/request'

// 获取 角色-菜单列表
export function getRoleMenu(data) {
  return request({
    url: '/admin/setting/webRoleMenu/list',
    method: 'post',
    data
  })
}
// 添加 角色-菜单
export function addRoleMenu(data) {
  return request({
    url: '/admin/setting/webRoleMenu/add',
    method: 'post',
    data: data
  })
}
// 更新 角色-菜单
export function updateRoleMenu(data) {
  return request({
    url: '/admin/setting/webRoleMenu/edit',
    method: 'post',
    data: data
  })
}
